export default "__VITE_ASSET__d5ad5d37__"